<div class="view-organization page">
  @if (!isLoading) {
    <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
    <div class="heading-wrapper">
      <h4>{{ getOrganizationHeading() }}</h4>
      <button class="primary" (click)="navigateToInfoRequest()" type="button">
        {{ 'pages.client.addInfoRequest' | translate }}
      </button>
    </div>
    <div class="content-wrapper">
      <app-content-side-nav
        [navItems]="navItems"
        [navItemsCounts]="{ notes: notesCount }"
        [activeItem]="initialActiveItem"
        [disabledItems]="disabledNavItems"
        [shouldTranslate]="true"
        [changeBack]="changeBack"
        (itemSelected)="onSectionChanged($event, !hasFormChanged)" />
      @if (!isLoading && legalEntity) {
        <div class="active-form">
          @if (activeItem === 'general') {
            <app-organization-general-info-form
              [legalEntity]="legalEntity"
              [countries]="countries"
              (legalEntityUpdated)="onLegalEntityUpdated($event)"
              (formChanged)="hasFormChanged = $event" />
          } @else if (activeItem === 'service_history') {
            <app-table
              [endpoint]="clientApplicationsEndpoint"
              [withSearch]="false"
              [withPagination]="true"
              [columns]="appTableColumns"
              [defaultFilters]="{ legalEntityId: legalEntityId! }"
              [getViewPathFn]="getServiceRequestViewPath"
              [draftsFirstKey]="'submittedOn'"
              responseKey="page"
              sortBy="SubmittedOn"
              sortDirection="desc" />
          } @else if (activeItem === 'activities') {
            <app-client-activities [client]="mappedClient!" [showDelete]="false" [legalEntityId]="legalEntityId" />
          } @else if (activeItem === 'notes') {
            <app-legal-entity-notes-form
              [legalEntityId]="legalEntityId!"
              [notes]="legalEntityNotes!"
              [isSubmittingNoteFiles]="isSubmittingNoteFiles"
              (pageChange)="onNotesPageChange($event)"
              (notesChanged)="loadNotes()"
              (formChanged)="hasFormChanged = $event" />
          } @else if (activeItem === 'officers') {
            <app-table
              [endpoint]="officersEndpoint"
              [columns]="officersColumns"
              [defaultFilters]="officersDefaultFilters"
              [withSearch]="false"
              [withPagination]="true"
              sortBy="fullName"
              sortDirection="asc"
              viewEntryPath="/klients/{id}" />
          }
        </div>
      }
    </div>
  } @else {
    <div class="fullscreen-loader">
      <app-spinner [isLoading]="isLoading" />
    </div>
  }
</div>

<app-confirm-modal
  [isOpen]="confirmModalOpen"
  (cancel)="confirmModalOpen = false"
  (confirm)="onSectionChanged(nextSection, true)"
  title="unsavedChanges"
  bodyText="unsavedChangesBody"
  confirmText="continue"
  denyText="cancelBack" />
